import { render, staticRenderFns } from "./Addstaff.vue?vue&type=template&id=039725c8&scoped=true&"
import script from "./Addstaff.vue?vue&type=script&lang=js&"
export * from "./Addstaff.vue?vue&type=script&lang=js&"
import style0 from "./Addstaff.vue?vue&type=style&index=0&id=039725c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039725c8",
  null
  
)

export default component.exports